import { render } from "./ExtractionChangesModal.vue?vue&type=template&id=6a3752dd&scoped=true"
import script from "./ExtractionChangesModal.vue?vue&type=script&lang=js"
export * from "./ExtractionChangesModal.vue?vue&type=script&lang=js"

import "./ExtractionChangesModal.vue?vue&type=style&index=0&id=6a3752dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3752dd"]])

export default __exports__